import axios from 'axios';
import { FETCH_USER } from './types';

export const fetchUser = () => async dispatch => {
    const res = await axios.get('/api/current_user');

    // Set localStorage based on authentication result
    if (res.data && res.data.id) {
        localStorage.setItem('isAuthenticated', 'true');
    } else {
        localStorage.setItem('isAuthenticated', 'false');
    }

    dispatch({ type: FETCH_USER, payload: res.data });
};

export const submitContactForm = (formData) => async () => {
    const res = await axios.post('/api/contact', formData);
    return res.data;
};
